module.exports = __webpack_public_path__ + "img/0Q3B5909-12_H_Foamcore_MockedUp.27621c64.jpg";